import React from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import { useSelector } from "react-redux";
import { ACCOUNT_LAYOUT_ROUTE } from "routes/account/accountPaths";
import { NotFound } from "components/modules/NotFound";
import accountRoutesConfig from "./accountRoutesConfig";
import { getRoutesProps } from "../getRoutesProps";

const AccountRoutes = () => {
  const { role, user } = useSelector(({ auth }) => auth);
  const routesPropsParams = {
    route: accountRoutesConfig(),
    role,
    permissions: user.permissions,
  };

  return (
    <Switch>
      {getRoutesProps(routesPropsParams).map((routeProps) => (
        <Route
          key={routeProps.label}
          path={routeProps.path}
          component={routeProps.component}
        />
      ))}
      <Route component={NotFound} />
      <Redirect from="*" to={ACCOUNT_LAYOUT_ROUTE} />
    </Switch>
  );
};

export default AccountRoutes;
